import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('signup-ui-lego');
export const getMetricsCounter = name => Metrics.counter(name);